// extracted by mini-css-extract-plugin
export default {"thumbnail":"styles_thumbnail__JRI6o","icon":"styles_icon__X3UYW"};